import React, { PropsWithChildren } from 'react';

/**
 * Column in a form. Is mainly used within FormRow.
 * Can contain nodes, elements and Strings as children.
 */
export function Column(props: PropsWithChildren) {
  return <div className="form-column">{props.children}</div>;
}
